<div class="ion-hide-md-down side-bar" [ngClass]="sideMenuState">
  <ion-item class="expand-collapse" lines="none" top button detail="false" (click)="onSideMenuExpandCollapseClick()">
    <i class="bi bi-chevron-double-left" slot="end"></i>
    <ion-label></ion-label>
  </ion-item>

  <app-side-menu class="ion-page" [menuState]="sideMenuState">
    
  </app-side-menu>
</div>